import { ThreadView } from "@/app/Threads/Components/ThreadView";
import { proDriverThreadRoute } from "@/app/ProDrivers/Common/Routes/proDriverRoutes";

export function ProDriverThreadScreen() {
  const { threadId } = proDriverThreadRoute.useParams();

  return <ThreadView key={threadId} id={threadId} />;
}
